/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Not_Found_DescriptionInputs */

const en_users_not_found_description = /** @type {(inputs: Users_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user may have been deleted or the link is invalid.`)
};

const pt_br2_users_not_found_description = /** @type {(inputs: Users_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este usuário pode ter sido excluído ou o link é inválido.`)
};

/**
* | output |
* | --- |
* | "This user may have been deleted or the link is invalid." |
*
* @param {Users_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_not_found_description = /** @type {((inputs?: Users_Not_Found_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Not_Found_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_not_found_description(inputs)
	return pt_br2_users_not_found_description(inputs)
});